import React, { useState } from "react";
import { useSelector } from "react-redux";
import BackIcon from '../../.././../../assests/MaterialLibrary/back-icon.png';
import classes from './UploadAuxiliary.module.css';
import UploadStep1 from "./UploadStep1";
import UploadStep2 from "./UploadStep2";
import UploadStep3 from "./UploadStep3";
import { onKeyDown } from "../../../../../service";
import SuccessProjectPopup from "../../../../lms-shared/UI/Popups/SuccessProjectPopup/SuccessProjectPopup";

const UploadAuxiliary = ({ setMessage, setAddItem }) => {

    const texts = useSelector(state => state.translate.texts);

    const [auxiliary, setAuxiliary] = useState(null)
    const [step, setStep] = useState(1);

    return (<SuccessProjectPopup close={() => setMessage(false)} color="#CCF0F085" title={texts.uploadAuxiliary} myWidth='554px' myHeight='560px'>
        <div className={classes.UploadAuxiliaryContainer}>
            {step > 1 && <img className={classes.BackIcon} src={BackIcon} alt="BackIcon" onClick={() => setStep(step - 1)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => setStep(step - 1))} />}
            {step === 1 && <UploadStep1 auxiliary={auxiliary} setAuxiliary={setAuxiliary} setStep={setStep} />}
            {step === 2 && <UploadStep2 auxiliary={auxiliary} setStep={setStep} setAddItem={setAddItem} />}
            {step === 3 && <UploadStep3 auxiliary={auxiliary} setMessage={setMessage} />}
        </div>
    </SuccessProjectPopup >)
}

export default UploadAuxiliary;